import messages from './common.json' with { type: 'json' };

export const commonSv: Readonly<typeof messages> = messages;
